import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, Output, signal, WritableSignal } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatOption, MatSelect } from '@angular/material/select';
import { UploadedByTypeComponentState } from '../../shared/state-interface';
import { StateManager } from '../../shared/state-manager.class';
import { UserType } from '../../shared/user-type.model';

@Component({
    selector: 'app-uploaded-by-types-component',
    standalone: true,
    imports: [
        CommonModule,
        ReactiveFormsModule,
        MatInputModule,
        MatSelect,
        MatOption
    ],
    templateUrl: './uploaded-by-types.component.html',
    styleUrl: './uploaded-by-types.component.css'
})
export class UploadedByTypesComponent {

    @Output() uploadedByTypeEvent = new EventEmitter<string>();
    
    private stateManager: StateManager = inject(StateManager);

    protected uploadedByType: FormControl = new FormControl("");

    private _uploadedByTypes: WritableSignal<UserType[]> = signal([]);

    public getState() {
        const state: UploadedByTypeComponentState = {} as UploadedByTypeComponentState;
        state.uploadedByTypeControl = this.uploadedByType;
        return state;
    }

    public restoreState(state: UploadedByTypeComponentState) {
        this.uploadedByType = state.uploadedByTypeControl;
        this._uploadedByTypes.set(this.stateManager.uploadedByTypes!);
        this.registerListener();
    }

    public init() {
        if (this._uploadedByTypes().length == 0) {
            const uploadedByTypes = this.stateManager.uploadedByTypes;

            if (uploadedByTypes == undefined) {
                this.uploadedByType.setValue("Loading...");
                this.loadUploadTypes();
            } else {
                this._uploadedByTypes.set(uploadedByTypes);
            }
        }
        this.registerListener();
    }

    public get uploadedByTypeCtl(): FormControl {
        return this.uploadedByType;
    }

    public get selectedUploadByType(): string {
        return this.uploadedByType.value;
    }

    protected get uploadedByTypes(): UserType[] {
        return this._uploadedByTypes()!;
    }

    protected async loadUploadTypes() {
        const userType = this.stateManager.getUserType();
        let uploadedByTypes: string[] = [];

        if (userType == "employee") {
            uploadedByTypes = ["employee", "dealer/dealer-rep", "customer"];
        } else if (userType == "dealer"
            || userType == "dealer-rep") {
            uploadedByTypes = ["dealer/dealer-rep", "customer"]
        }

        if (uploadedByTypes.length > 0) {
            this._uploadedByTypes.set(UserType.createUserTypes(uploadedByTypes));
            this.stateManager.uploadedByTypes = this._uploadedByTypes();
            this.uploadedByType.setValue("");
        }
    }

    private registerListener() {
        this.uploadedByType.valueChanges.subscribe(() => {
            this.uploadedByTypeEvent.emit(this.uploadedByType.value);
        });
    }
}
